import { Button } from '@material-tailwind/react'
import React from 'react'
import AIcon from './AIcon'
import { useShared } from '../../hooks/useShared'

export default function AAlert() {

    const { message, setMessage } = useShared()

    React.useEffect(() => {
        setTimeout(() => {
            setMessage(null)
        }, 1000 * 10);
    }, [])


    return (
        <div className={`mAlert  ${message !== null ? "h-13 px-3 py-2" : "h-0"}  `}>
            <span> {message} </span>
            <Button className=' bg-transparent hover:shadow-none shadow-none p-0' onClick={() => setMessage(null)}>
                <AIcon className="text-green-700" name="close" size={20} />
            </Button>
        </div>

    )
}
